import type {
  BetterstartPresetDefinition,
  BetterstartPresetId
} from '@cli-types/preset-engine/presets.js'
import { createRegistry } from '@core-engine/installable/registry.js'
import { blogPreset } from '@next-adapter/presets/blog/preset.js'
import { portfolioPreset } from '@next-adapter/presets/portfolio/preset.js'

export const presetRegistry: Record<string, BetterstartPresetDefinition> = {
  blog: blogPreset,
  portfolio: portfolioPreset
}

const presets = createRegistry<BetterstartPresetDefinition, BetterstartPresetId>(
  presetRegistry,
  'preset'
)

export const listPresetDefinitions = presets.list
export const getPresetDefinition = presets.get
export const isPresetId = presets.is
export const formatUnknownPresetMessage = presets.formatUnknownMessage
